import { InjectionToken } from '@angular/core';
// eslint-disable-next-line @typescript-eslint/naming-convention
export const LOGIN_SMART_ID_ENABLED: InjectionToken<boolean> = new InjectionToken<boolean>('smartId', {
  factory: () => false
});
